export enum ActionTypes {
  SAVE_ENTITIES = 'SAVE_ENTITIES'
}
